import CommonCss from "lib/common/style.module.scss";

import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import { Page, Preloader } from "lib/common";
import { checkActivityFetching } from "selectors/activity";
import { getSelectedBusinessData } from "selectors/businesses";
import { getTextsData } from "selectors/texts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import ActivityActions from "actions/ActivityActions";
import ActivityItem from "nlib/pages/ActivityPage/lib/ActivityItem";
import Arrays from "utils/Arrays";
import Async from "utils/Async";
import Button from "nlib/ui/Button";
import Constants from "const/Constants";
import PageHeader from "lib/common/PageHeader";
import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";

const ActivityPage = () => {
  const history = useHistory();

  const dispatch = useDispatch();

  const activityFetching = useSelector(checkActivityFetching);

  const [activityData, setActivityData] = useState([]);

  const [showMoreShown, setShowMoreShown] = useState(false);

  const { uiTexts } = useSelector(getTextsData);

  const { id: selectedBusinessId, name: businessName } = useSelector(getSelectedBusinessData);

  const [currentPage, setCurrentPage] = useState(1);

  const todayData = activityData.filter(({ timestamp }) => moment(timestamp).isSame(new Date(), "day"));

  const thisMonthData = activityData.filter(({ timestamp }) => {
    return !moment(timestamp).isSame(new Date(), "day") && moment(timestamp).isSame(new Date(), "month");
  });

  const earlyData = activityData.filter(({ timestamp }) => {
    return !moment(timestamp).isSame(new Date(), "month");
  });

  const updateItems = useCallback((page = 0) => {
    dispatch(
      ActivityActions.fetchActivityList(
        {},
        page * Constants.TABLE_PAGE_SIZE,
        Constants.TABLE_PAGE_SIZE,
        false,
        true
      )
    ).then((result) => {
      if (!Array.isArray(result)) return;

      const newItems = result.filter(({ id }) => !Arrays.findById(activityData, id));

      setActivityData([...newItems, ...activityData]);
      if (newItems.length < Constants.TABLE_PAGE_SIZE) return;
      updateItems(page + 1);
    });
  }, [activityData, dispatch]);

  const handleShowMoreClick = useCallback(() => {
    setCurrentPage((prev) => prev + 1);
  }, []);

  useEffect(() => {
    return Async.setTimeout(() => updateItems(), Constants.DATA_LIST_UPDATE_INTERVAL);
  }, [updateItems]);
  useEffect(() => {
    (async() => {
      const result = await dispatch(
        ActivityActions.fetchActivityList(
          {},
          (currentPage - 1) * Constants.TABLE_PAGE_SIZE,
          Constants.TABLE_PAGE_SIZE,
          false,
          false
        )
      );

      if (!Array.isArray(result)) return;
      setShowMoreShown(result.length === Constants.TABLE_PAGE_SIZE);
      setActivityData((prev) => [
        ...prev,
        ...result.filter((item) => !Arrays.findById(prev, item.id))
      ]);
    })();
  }, [currentPage, dispatch, history, selectedBusinessId]);

  return (
    <Page className={Css.activityPage}>
      <PageHeader subTitle={businessName} />
      {!!todayData.length && (
        <div className={Css.container}>
          <div className={Css.section}>
            <div className={Css.title}>{uiTexts.today}</div>
            {todayData.map((item) => <ActivityItem key={item.id} item={item} />)}
          </div>
        </div>
      )}
      {!!thisMonthData.length && (
        <div className={Css.container}>
          <div className={Css.section}>
            <div className={Css.title}>{uiTexts.thisMonth}</div>
            {thisMonthData.map((item) => <ActivityItem key={item.id} item={item} />)}
          </div>
        </div>
      )}
      {!!earlyData.length && (
        <div className={Css.container}>
          <div className={Css.section}>
            <div className={Css.title}>{uiTexts.early}</div>
            {earlyData.map((item) => <ActivityItem key={item.id} item={item} />)}
          </div>
        </div>
      )}
      {showMoreShown && (
        <div className={Css.showMore} onClick={handleShowMoreClick}>
          <Button large outline>{uiTexts.showMore}</Button>
        </div>
      )}
      {!activityFetching && !activityData.length && (
        <div className={CommonCss.noDataContent}>
          <div>
            <div><Icons.Lightning /></div>
            <div>{uiTexts.noActivity}</div>
          </div>
        </div>
      )}
      {activityFetching && <Preloader absolute />}
    </Page>
  );
};

export default React.memo(ActivityPage);
